<template>
  <div class="sub-header">
    <DropdownDatePicker />
  </div>
</template>

<script>
import { DropdownDatePicker } from '@/components/content/DropdownDatePicker';

export default {
  name: 'SubHeader',
  components: {
    DropdownDatePicker,
  },
};
</script>

<style lang="scss" scoped>
.sub-header {
  width: 100%;
  position: fixed;
  padding: var(--ds-spacing-stack-nano) 0 var(--ds-spacing-stack-nano) 60px;
  z-index: var(--zindex-1);
  background-color: var(--ds-color-reverse);
  justify-content: flex-start;
  box-shadow: var(--ds-dark-dropshadow-1);
  font-size: var(--ds-font-size-xs);
  font-weight: var(--ds-font-weight-semibold);
  color: var(--ds-color-white);
  top: 58px;
  right: 0;
}
</style>
